import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootStateTypeExtra } from '@store/types'

export interface ThreeDViewState {
  activeModel: string | null
  selectedLevelId: string
}

const initialState: ThreeDViewState = {
  activeModel: null,
  selectedLevelId: '',
}

const threeDViewSlice = createSlice({
  name: 'threeDView',
  initialState,
  reducers: {
    setThreeDView(state, action: PayloadAction<ThreeDViewState>) {
      return {
        ...state,
        ...action.payload,
      }
    },
    setSelectedLevelId(state, action: PayloadAction<string>) {
      return {
        ...state,
        selectedLevelId: action.payload,
      }
    },
    resetThreeDView(state) {
      return {
        ...state,
        activeModel: null,
        selectedLevelId: '',
      }
    },
  },
})

export const { setThreeDView, setSelectedLevelId, resetThreeDView } =
  threeDViewSlice.actions

export const selectThreeDView = (state: RootStateTypeExtra) => state.threeDView

export default threeDViewSlice.reducer
